import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import TwoFactorDigitsComponent from '@/views/components/two-factor-digits/index.component'

type Props = {
  twoFactorVerified: TwoFactorStatus
}

const TwoFactorActiveThreeComponent = ({ twoFactorVerified }: Props) => {
  const { t } = useTranslation()

  return (
    <Box mt={2}>
      <Typography className="fontWeight-500 ">
        {t('twoFactor.finishTwoAuthTitle')}
      </Typography>
      <Box mt={1}>
        <Typography variant="body2">
          {t('twoFactor.setupAuthMessage')}
        </Typography>
      </Box>
      <Box mb={4} mt={4}>
        <TwoFactorDigitsComponent
          verificationCode
          twoFactorStatus={twoFactorVerified}
        />
      </Box>
    </Box>
  )
}

export default TwoFactorActiveThreeComponent
